// @ts-nocheck

import { History, Location } from 'history';
import { Dispatch } from 'redux';

import Client, { isIOSEmbeddedAndStandalone } from '../client';
import { openKLView } from '../modules/koh-lanta/actions/routes';

import InAppBrowser from './plugins/InAppBrowser';
import Routes from './routes';
import isBetbuilder, { getBetbuilderMatchId } from './routes/isBetbuilder';
import isHistoryItemDetail from './routes/isHistoryItemDetail';
import isLineUp, { getLineUpMatchId } from './routes/isLineUp';

type NavigateBackPropsType = {
  history: History;
  location: Location;
  dispatch?: Dispatch;
  openGRView?: () => void;
  openBoomView?: () => void;
};

export const navigateBack = ({ history, location, dispatch, openGRView, openBoomView }: NavigateBackPropsType) => {
  if (location.hash) {
    history.goBackOrReplace(location.pathname);
  } else if (isBetbuilder(location.pathname)) {
    const matchId = getBetbuilderMatchId(location.pathname);
    history.goBackOrReplace(matchId !== null ? `/match/${matchId}` : '/');
  } else if (isHistoryItemDetail(location.pathname)) {
    history.goBackOrReplace('/history');
  } else if (Routes.isSportsSubMenu(location.pathname)) {
    history.goBackOrReplace('/menu');
  } else if (Routes.isKL(location.pathname, { exact: false })) {
    dispatch(openKLView());
  } else if (Routes.isGR(location.pathname, { exact: false })) {
    openGRView();
  } else if (Routes.isBoom(location.pathname, { exact: false })) {
    openBoomView();
  } else if (isLineUp(location.pathname)) {
    const matchId = getLineUpMatchId(location.pathname);
    history.goBackOrReplace(matchId !== null ? `/match/${matchId}` : '/');
  } else {
    history.goBackOrReplace('/');
  }
};

export const openUrl = (url, options = { inNewTab: true, delay: 0 }) => {
  if (Client.embed && InAppBrowser.isAvailable()) {
    InAppBrowser.open(url);
  } else {
    openUrlBrowser(url, options);
  }
};

export const openUrlBrowser = (url, options = { inNewTab: true, delay: 0 }) => {
  if (window) {
    if (isIOSEmbeddedAndStandalone) {
      window.location.href = url;
    } else {
      const newTab = options.inNewTab === undefined || options.inNewTab;

      setTimeout(() => {
        window.open(url, newTab ? '_blank' : '_self');
      }, options.delay ?? 0);
    }
  }
};
